import { render, staticRenderFns } from "./backup2.vue?vue&type=template&id=1cb4a70a&"
import script from "./backup2.vue?vue&type=script&lang=js&"
export * from "./backup2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports